export enum PromoterDetailViewType{    
    Detail,
    Last20Transactions,
    SearchTransactions,
    CreditAdjustment
}
export enum TransactionType{
    TopUp,
    MessagingAll,
    MessagingText,
    MessagingImage,
    MessagingUrl,
    MessagingAudio,
    MessagingVideo,
    PromotionTopUp,
    Adjustment,
    ServiceDirectory
}
export enum PromoterState{
    Approved,
    AwaitingApproval,
    Rejected,
    Suspended
}
export enum CreditTransactionReportType{
    ALL,
    Income,
    IncomeAndLiability,
    Expenditure
}
 export function getTransactionTypeDisplay(type: TransactionType): string {
    switch (type) {
      case TransactionType.TopUp: return 'TopUp';
      case TransactionType.MessagingAll: return 'Messaging All';
      case TransactionType.MessagingText: return 'Messaging Text';
      case TransactionType.MessagingImage: return 'Messaging Image';
      case TransactionType.MessagingUrl: return 'Messaging URL';
      case TransactionType.MessagingAudio: return 'Messaging Audio';
      case TransactionType.MessagingVideo: return 'Messaging Video';
      case TransactionType.PromotionTopUp: return 'Promotion TopUp';
      case TransactionType.Adjustment: return 'Adjustment';
      case TransactionType.ServiceDirectory: return 'Service Directory';
      default: return 'Unknown';
    }
  }